import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { Props } from './FolderDropdown';
import { AppState } from '../../../../../types/store';
import { getCurrentlyViewedFolderId } from '../../../../selectors/gallectionSection';
import { setSelectedFolderId } from '../../../../actions/gallectionSection';
import { getFolders } from '../../../../selectors/folders';

export type StateProps = Pick<Props, 'folders' | 'currentlyViewedFolderId'>;
export type DispatchProps = Pick<Props, 'setSelectedFolderId'>;
export type OwnProps = Without<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  AppState
> = state => ({
  folders: getFolders(state),
  currentlyViewedFolderId: getCurrentlyViewedFolderId(state),
});
const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {
  setSelectedFolderId,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
);
